import React from 'react';

import { useCurrentUserPermissions } from 'src/hooks/user';
import { NotFoundErrorPage } from 'src/pages/not-found';

import {
  EmployersTableClearVerifyStaff,
  EmployersTablePEOPayrollProviderStaff,
  EmployersTablePEOStaff,
} from './components';

export const EmployersTable: React.FC = () => {
  const { hasPlatformRoles, hasPeoRoles, isPeoPayrollProviderUser } = useCurrentUserPermissions();

  if (hasPlatformRoles) return <EmployersTableClearVerifyStaff />;
  if (hasPeoRoles) return <EmployersTablePEOStaff />;
  if (isPeoPayrollProviderUser) return <EmployersTablePEOPayrollProviderStaff />;

  return <NotFoundErrorPage />;
};
